import { typedFetch } from "@/lib/helpers";
import { getAlarmRuleUrl } from "./api-url.constants";
import { API_METHODS } from "../shared";

export const deleteAlarmRule = async (id: string): Promise<void> => {
  const result = await typedFetch(getAlarmRuleUrl(id), {
    method: API_METHODS.DELETE,
  });

  if (!result.ok) {
    throw new Error("Failed to delete alarm rule");
  }
};
